module.exports = __webpack_public_path__ + "static/MobileAppLearning@2x-a195a474b600d70a1e6fe8e9a4d4ab42.png";